<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="box">
          <h1 class="title">緊急性</h1>
          <div v-if="user.permission.admin">
            <router-link class="button is-primary" to="/settings/urgency/new">緊急性新規登録</router-link>
          </div>
        </div>
        <table class="table is-bordered pricing__table is-fullwidth">
          <thead>
            <tr>
              <th v-for="header in headers" v-bind:key="header">
                {{ header }}
              </th>
            </tr>
          </thead>
          <draggable v-model="myList" tag="tbody">
            <tr v-for="item in myList" :key="item.id">
              <td scope="row" class="cursor-drag">
                <span class="icon">
                  <i class="fas fa-bars"></i>
                </span>
              </td>
              <td>{{ item.name }}</td>
              <td><img :src=" item.img_path " alt="アイコンイメージ" width=32 height="32"></td>
              <td v-if="item.deleted_at === '1'">利用中</td>
              <td v-else><span class="has-text-danger">利用停止中</span></td>
              <td>
                <div v-if="user.permission.admin">
                  <router-link :to="{ name: 'editUrgency', params: { urgencyId: item.id }}">
                    <button class="button is-link">編集</button>
                  </router-link>
                </div>
              </td>
            </tr>
          </draggable>
        </table>
      </div>
    </section>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'

export default {
  data: function(){
    return {
      headers:['','緊急性表示名','アイコンイメージ','状態','操作'],
    }
  },
  components:{
    draggable,
  },
  computed: {
    myList: {
        get() {
          return this.list
        },
        set(val) {
          //並び替えをDBへ保存
          this.$store.dispatch('item/updateUrgencyList', {list: val})
        }
    },
    ...mapState({
      list: state => state.item.urgencys,
      apiStatus: state => state.item.apiStatus,
      user: state => state.auth.user,
    })
  },
  mounted() {
    this.$store.dispatch('item/getItems', {})
  },
}
</script>
<style scoped>
  .cursor-drag{
    cursor: move;
  }
</style>